import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { detectRegion } from '../../utils/geoDetect';

/**
 * Renders FallbackComponent immediately (no blank flash), then redirects to the
 * region-specific path once geo-detection resolves.
 *
 * paths: { in: '/in/products/forwarding', uae: '...', us: '...' }
 * Omit a key to keep the user on the current page for that region.
 */
export default function RegionalProductRedirect({ paths, FallbackComponent }) {
  const navigate = useNavigate();
  const done = useRef(false);
  // Snapshot paths at mount so the effect dep array stays stable.
  // If paths changed after mount the redirect already fired (done.current = true), so staleness is intentional.
  const pathsRef = useRef(paths);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    detectRegion().then(region => {
      const target = pathsRef.current[region];
      if (target) navigate(target, { replace: true });
    });
  }, [navigate]);

  return <FallbackComponent />;
}
